import React from 'react';
import AiListingCards from './AiListingCards';
import AiQuoteCards from './AiQuoteCards';
import AiJobCards from './AiJobCards';
import AiListingDraftCard from './AiListingDraftCard';
import AiMultiLegRouteCards from './AiMultiLegRouteCards';

export default function AiResultRenderer({ result, role, navigate, onTriggerMessage }) {
  if (!result?.type) {
    return null;
  }

  if (result.type === 'listing_list') {
    return (
      <AiListingCards
        result={result}
        role={role}
        navigate={navigate}
        onTriggerMessage={onTriggerMessage}
      />
    );
  }

  if (result.type === 'quote_list') {
    return (
      <AiQuoteCards
        result={result}
        onTriggerMessage={onTriggerMessage}
      />
    );
  }

  if (result.type === 'job_list') {
    return (
      <AiJobCards
        result={result}
        navigate={navigate}
        onTriggerMessage={onTriggerMessage}
      />
    );
  }

  if (result.type === 'listing_draft') {
    return (
      <AiListingDraftCard
        result={result}
        navigate={navigate}
      />
    );
  }

  if (result.type === 'multi_leg_route') {
    return (
      <AiMultiLegRouteCards
        result={result}
        role={role}
        navigate={navigate}
        onTriggerMessage={onTriggerMessage}
      />
    );
  }

  return null;
}
